import React from 'react';
import { FiArrowLeft, FiRefreshCw } from 'react-icons/fi';
import { useNavigate } from '@tanstack/react-router';
import { AuthHeader } from './AuthHeader';

export const CheckEmailPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen w-full flex bg-[#030303] flex-col overflow-hidden font-['Inter'] selection:bg-blue-500/30">
      {/* Background Glow */}
      <div
        className="absolute pointer-events-none rounded-full"
        style={{
          width: '1308px',
          height: '449px',
          bottom: '-150px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(to right, #2F80ED, #942FED)',
          opacity: 0.5,
          filter: 'blur(260px)',
          zIndex: 0,
        }}
      />

      <AuthHeader />

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center w-full max-w-[500px] mx-auto px-6 py-20">
        {/* Back Button */}
        <div className="w-full flex justify-start mb-6">
          <button
            onClick={() => window.history.back()}
            className="w-10 h-10 rounded-full bg-[#1a1a1a] hover:bg-[#2a2a2a] flex items-center justify-center transition-colors border border-white/5 cursor-pointer shadow-lg"
          >
            <FiArrowLeft className="text-zinc-300" size={18} />
          </button>
        </div>

        <div className="w-full text-center mb-8">
          <h1
            onClick={() => navigate({ to: '/forgot-password' })} // Route changed to forgot-password
            className="text-white text-[32px] md:text-[40px] font-medium leading-[1.1] mb-4 cursor-pointer"
            style={{ fontFamily: "'Funnel Display', sans-serif" }}
          >
            Check your email
          </h1>
          <p className="text-[#a1a1aa] text-[15px] font-medium leading-[1.6] max-w-[420px] mx-auto">
            We sent a password reset link to <span className="text-white">t*h@gmail.com</span>. If
            you don't see it, check your spam folder
          </p>
        </div>

        <div className="flex flex-col items-center gap-4">
          <button className="text-[#a1a1aa] hover:text-white transition-colors text-[14px] font-medium flex items-center gap-2 group cursor-pointer">
            Didn't get the email?
            <span className="text-[#3B82F6] hover:text-blue-400 transition-colors flex items-center gap-1.5 focus:outline-none">
              Resend email{' '}
              <FiRefreshCw
                size={14}
                className="group-hover:rotate-180 transition-transform duration-500"
              />
            </span>
          </button>
        </div>
      </div>
    </div>
  );
};
